import axios from 'axios';

// Use relative URL for API calls - works on any domain
const API = '/api';

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if ((status === 401 || status === 403) && window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Tours - with language support
export const getTours = (params) => api.get('/tours', { params });
export const getAdminToursList = (skip = 0, limit = 12, tourType) => api.get('/admin/tours-list', { params: { skip, limit, tour_type: tourType || undefined } });
export const getAdminToursCounts = () => api.get('/admin/tours-counts');
export const getTourCategories = (tourType) => api.get('/admin/tour-categories', { params: { tour_type: tourType } });
export const createTourCategory = (data) => api.post('/admin/tour-categories', data);
export const deleteTourCategory = (id) => api.delete(`/admin/tour-categories/${id}`);
export const getTourBySlug = (slug, lang = 'tr') => api.get(`/tours/${slug}`, { params: { lang } });
export const getRelatedTours = (slug, lang = 'tr') => api.get(`/tours/${slug}/related`, { params: { lang } });
export const getAdminTourDepartures = (tourId) => api.get(`/admin/tours/${tourId}/departures`);
export const updateTourDateSetting = (tourId, date, data) => api.put(`/admin/tours/${tourId}/date-settings/${date}`, data);
export const createTour = (data) => api.post('/tours', data);
export const updateTour = (id, data) => api.put(`/tours/${id}`, data);
export const deleteTour = (id) => api.delete(`/tours/${id}`);

// Bookings
export const createBooking = (data) => api.post('/bookings', data);
export const getBookings = (params) => api.get('/bookings', { params });
export const getBooking = (id) => api.get(`/bookings/${id}`);
export const updateBookingStatus = (id, status) => api.put(`/bookings/${id}/status`, { status });
export const deleteBooking = (id) => api.delete(`/bookings/${id}`);

// Blog - with language support
export const getBlogPosts = (params) => api.get('/blog', { params });
export const getBlogPostBySlug = (slug, lang = 'tr') => api.get(`/blog/${slug}`, { params: { lang } });
export const createBlogPost = (data) => api.post('/blog', data);
export const updateBlogPost = (id, data) => api.put(`/blog/${id}`, data);
export const deleteBlogPost = (id) => api.delete(`/blog/${id}`);

// Contact
export const submitContactForm = (data) => api.post('/contact', data);
export const getContactForms = () => api.get('/contact');

// File Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Slider - with language support
export const getSliderImages = (lang = 'tr') => api.get('/slider', { params: { lang } });
export const getAllSliderImages = () => api.get('/slider/all');
export const createSliderImage = (data) => api.post('/slider', data);
export const updateSliderImage = (id, data) => api.put(`/slider/${id}`, data);
export const deleteSliderImage = (id) => api.delete(`/slider/${id}`);

// Calendar - with language support
export const getTourCalendar = (lang = 'tr') => api.get('/calendar', { params: { lang } });

export default api;

export const getPublicSiteSettings = () => api.get('/site-settings/public');
export const getAdminSiteSettings = () => api.get('/admin/site-settings');
export const updateAdminSiteSettings = (data) => api.put('/admin/site-settings', data);
export const getSeoOverride = (path) => api.get('/seo', { params: { path } });
export const getAdminSeo = () => api.get('/admin/seo');
export const saveAdminSeo = (data) => api.put('/admin/seo', data);
export const deleteAdminSeo = (path) => api.delete('/admin/seo', { params: { path } });
export const getAnalyticsOverview = (params) => api.get('/admin/analytics/overview', { params });
